import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';

export function initBundleScrollbar(el) {
    for (let scrollbar of el) {
        let childrenCount = scrollbar.querySelectorAll('.swiper-wrapper > *').length;
        let breakpoints = {
            xs: {
                items: 1.2,
            },
            sm: {
                items: 1.2,
            },
            md: {
                items: 1.2,
            },
            lg: {
                items: 2.2,
            },
            xlg: {
                items: 2.2,
            }
        }
        let gridBreakpoints = {};
        gridBreakpoints.sm = 768;
        gridBreakpoints.md = 1024;
        gridBreakpoints.lg = 1250;
        gridBreakpoints.xlg = 1670;
        if (typeof GLOBALS!== "undefined") {
            gridBreakpoints.sm = GLOBALS.gridBreakpoints.sm;
            gridBreakpoints.md = GLOBALS.gridBreakpoints.md;
            gridBreakpoints.lg = GLOBALS.gridBreakpoints.lg;
            gridBreakpoints.xlg = GLOBALS.gridBreakpoints.xlg;
        }
        Swiper.use([Autoplay, Navigation]);
        new Swiper(scrollbar, {
            speed: 500,
            initialSlide: 0,
            spaceBetween: 30,
            navigation: {
                nextEl: scrollbar.querySelector('.swiper-button-next'),
                prevEl: scrollbar.querySelector('.swiper-button-prev'),
            },
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xs.items,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: breakpoints.sm.items,
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: breakpoints.md.items,
                    spaceBetween: 15
                },
                1250: {
                    slidesPerView: breakpoints.lg.items,
                },
                1670: {
                    slidesPerView: breakpoints.xlg.items,
                }
            }
        });
    }
}